import * as React from 'react';
import * as styles from './ibd-ecm-investor-contact.css';

export const helpDetails = [
  {
    label: 'US & Canada',
    detail: '+1.855.627.7830'
  },
  {
    label: 'Europe & Africa',
    detail: '+44.20.7051.7999'
  },
  {
    label: 'Asia',
    detail: '+65.6889.3079'
  },
  {
    label: 'Email',
    detail: <a href="mailto:gs-marquee-help@gs.com">gs-marquee-help@gs.com</a>
  }
];

export class IbdEcmInvestorContact extends React.Component {
  renderRow(label: string, detail: React.ReactNode): JSX.Element {
    return (
      <div key={label} className={styles.ibdEcmInvestorContactRow}>
        <span className={styles.ibdEcmInvestorContactRowLabel}>{label}</span>
        <span className={styles.ibdEcmInvestorContactRowDetail}>{detail}</span>
      </div>
    );
  }

  render(): JSX.Element {
    return (
      <div className={styles.ibdEcmInvestorContact}>
        <div>
          <div className={styles.ibdEcmInvestorContactHeading}>
            Having Trouble? Contact HelpDesk
          </div>
          {helpDetails.map(help => this.renderRow(help.label, help.detail))}
        </div>
      </div>
    );
  }
}
